
import { Component, Input, OnChanges } from '@angular/core';
import { ServiceService } from '../../../../injections/service.service';
import * as moment from 'moment';


@Component({
  selector: 'service-comments',
  templateUrl: '../../templates/partials/comments-service.html'
})
export class CommentsServiceComponent{

  @Input() comments:Array<object>;
  @Input() clintuComment:any;
  @Input() profComment:any;
  @Input() id;
  public insertComment: string;
  public incidence: boolean = false;
  public cleanerC: boolean = false;
  public editCleanerC: boolean = false;
  public editClintuC: boolean = false;
  public clintuCommentCopy;
  public profCommentCopy;

  constructor(private serviceService: ServiceService){}

  public addComment() {

    var object;
    if(this.incidence){
      object = {
        managerUserId: 9,
        text: this.insertComment 
      }
      this.insertCommentIncidence(object);
    }else if(this.cleanerC){
      object = {
        text: this.insertComment 
      }
      this.insertCommentCleaner(object);
    }else{
      object = {
        type: "reload",
        text: this.insertComment 
      }
      this.insertCommentReload(object);
    }
  }

  public setCommentType(comment: any) {
    if(comment.type == "reload") return 'c-comment';
    else if(comment.type == "cancel") return 'c-comment--alert';
    else if(comment.type == "user") return 'c-comment--user';
    else if(comment.type == "incidence") return 'c-comment--alert';
    else return 'c-comment';
  }

  public setCommentIncidence() {
      this.cleanerC = false;
      this.incidence = (this.incidence) ? false : true;
  }

  public setCleanerComment() {
    this.incidence = false;
    this.cleanerC = (this.cleanerC) ? false : true;
  }

  public insertCommentCleaner(object: object){
    this.serviceService.addProfComment(this.id,object).subscribe(result => {
      if(result == "OK"){
        this.profComment["text"] = this.insertComment;
        this.insertComment = null;
      }
    });
  }

  public insertCommentReload(object: object) {
    this.serviceService.addServiceComment(this.id,object).subscribe( result => {
        let comment = {
          text: this.insertComment,
          date: moment().format("DD/MM/YYYY"),
          hour: moment().format("HH:mm"),
          type: "reload"
        }
        this.comments.unshift(comment);
        this.insertComment = null;
    });
  }
  public insertCommentIncidence(object: object){
    this.serviceService.addServiceCommentIncidence(this.id,object).subscribe( result => {
      let comment = {
        text: this.insertComment,
        date: moment().format("DD/MM/YYYY"),
        hour: moment().format("HH:mm"),
        type: "incidence",
        author_type: "admin"
      }
      this.comments.unshift(comment);
      this.insertComment = null;
  });
  }

  public editCommentClintu(value: boolean){
    this.editClintuC = value;
    this.clintuCommentCopy = JSON.parse(JSON.stringify(this.clintuComment["text"]));
  }

  public editCommentCleaner(value: boolean) {
    this.editCleanerC = value;
    this.profCommentCopy = JSON.parse(JSON.stringify(this.profComment["text"]));
  }

  public updateCleanerComment(){
    let data = {
      text: this.profCommentCopy
    }
    this.serviceService.editCommentCleaner(this.id,data).subscribe(result => {
      if(result == "OK"){
        this.profComment["text"] = this.profCommentCopy;
        this.editCleanerC = false;
      }
    });
  }

  public updateClintuComment(){
    let data = {
      text: this.clintuCommentCopy
    }
    this.serviceService.editCommentClintu(this.id,data).subscribe(result => {
      if(result == "OK"){
        this.clintuComment["text"] = this.clintuCommentCopy;
        this.editClintuC = false;
      }
    });
  }


}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/comments-service.component.ts